<template>
  <div class="subscriptions subscriptions-slider">
    <div class="glide" ref="slider">
      <div class="glide__track" data-glide-el="track">
        <ul class="glide__slides">
          <li class="glide__slide" @click="selectSubscription(subscription)" v-for="(subscription, index) in subscriptions" :class="{ 'active': (selected && selected.id === subscription.id)}" :key="index">
            <div class="inner">
              <div class="subscription-name">
                <div class="subscrition-name__inner">
                  <p>{{ subscription.libellePublic }}</p>
                  <p class="capacity">{{ subscription.capacite.capacite }} <span>{{ subscription.capacite.unit.toLowerCase() }}</span></p>
                </div>
              </div>
              <div class="subscription-price">
                <div class="main-price"><span v-html="subscription.prices.regular"></span></div>
                <div class="subscription-informations-text">
                  <p v-if="subscription.prixInitial > subscription.prixMajore">x{{ subscription.promoDuration }} puis <span v-html="subscription.prices.initial"></span></p>
                  <p v-if="subscription.dureeEngagement">Engagement {{ subscription.commitment }}</p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="glide__arrows" data-glide-el="controls" v-if="subscriptions.length > 3">
        <button class="glide__arrow glide__arrow--left" data-glide-dir="<"><span class="fi-rr-arrow-small-left"></span></button>
        <button class="glide__arrow glide__arrow--right" data-glide-dir=">"><span class="fi-rr-arrow-small-right"></span></button>
      </div>
    </div>
  </div>
</template>

<script>
import Glide, { Controls, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
import Sticky from "sticky-js";

export default {
  name: 'SubscriptionSlider',
  props: {
    selected: Object,
    subscriptions: Array
  },
  data () {
    return {
      slider: null
    }
  },
  mounted() {
    this.destroySlider()
    this.mountSlider()
    this.preventBlurry()
  },
  methods: {
    mountSlider () {
      this.slider = new Glide(this.$refs.slider, {
        startAt: this.currentIndex,
        type: 'slider',
        bound: true,
        rewind: false,
        perView: 3,
        gap: 11,
        breakpoints: {
          630: {
            perView: 2
          }
        }
      }).mount({ Controls, Breakpoints, Swipe })
    },
    destroySlider () {
      if(this.slider) this.slider.destroy()
    },
    preventBlurry () {
      this.slider.on(['mount', 'mount.after', 'run'], function() {
        setTimeout(() => {
          const currentCarousel = document.querySelector('.glide .glide__slides');
          currentCarousel.style.transform = 'translate3d(' + Math.round(currentCarousel.style.transform.substring(currentCarousel.style.transform.indexOf('(') + 1, currentCarousel.style.transform.indexOf('px'))) + 'px, 0px, 0px) translateZ(0)';
        }, 500);
      })
    },
    selectSubscription (subscription) {
      this.$emit('change', subscription)
    }
  },
  computed: {
    currentIndex () {
      let currentIndex = 0
      let chunks = []

      const mq = window.matchMedia( "(min-width: 630px)" )

      if(mq.matches){

        const chunkSize = 3
        for (let i = 0; i < this.subscriptions.length; i += chunkSize) {
          chunks.push(this.subscriptions.slice(i, i + chunkSize))
        }

        for (let i = 0; i < chunks.length; i++) {
          if(this.selected) {
            let index = chunks[i].findIndex(subscription => {
              return subscription.id === this.selected.id;
            })

            if(index > -1){
              currentIndex = i * 3
            }
          }
        }
      } else {

        const chunkSize = 2
        for (let i = 0; i < this.subscriptions.length; i += chunkSize) {
          chunks.push(this.subscriptions.slice(i, i + chunkSize))
        }

        for (let i = 0; i < chunks.length; i++) {
          if(this.selected) {
            let index = chunks[i].findIndex(subscription => {
              return subscription.id === this.selected.id;
            })

            if(index > -1){
              currentIndex = i * 2
            }
          }
        }
      }

      return currentIndex
    }
  },
  watch: {
    subscriptions () {
      this.destroySlider()
      setTimeout(() => {
        this.mountSlider()
        this.preventBlurry()
      }, 10)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.subscriptions{
  .glide{
    width: 100%;
    position: relative;

    .glide__track{
      width: 100%;

      .glide__slides{
        .glide__slide{
          width: auto;
          border: 1px solid darken($white, 10%);
          position: relative;
          cursor: pointer;
          min-height: 270px;
          @include radius(5px);
          @include transition();

          .inner {
            width: 100%;
            text-align: center;

            .subscription-name, .subscription-price{
              padding: 20px;
              width: 100%;
            }

            .subscription-name{
              display: flex;
              align-items: center;
              justify-content: center;
              height: 150px;
              border-bottom: 1px solid darken($white, 10%);
              font-size: px2rem(12px);
              line-height: px2rem(16px);
              font-weight: $fontSemiBold;

              p.capacity{
                margin-top: 20px;
                font-size: px2rem(18px);
                font-weight: $fontSemiBold;

                span{
                  text-transform: capitalize;
                }
              }
            }

            .subscription-price{
              .subscription-informations-text{
                min-height: 28px;
                font-size: px2rem(10px);
                line-height: px2rem(14px);
              }
            }
          }

          &:after {
            display: inline-block;
            content: '';
            position: absolute;
            top: -1px;
            left: -1px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            border: 2px solid $black;
            opacity: 0;
            @include radius(5px);
            @include transition();
          }

          &:hover {
            &:after {
              opacity: 1;
            }
          }

          &.active {
            color: $primary;

            &:after {
              opacity: 1;
              border: 2px solid $primary;
            }
          }
        }
      }
    }

    .glide__arrows{
      .glide__arrow{
        display: inline-block;;
        height: 40px;
        width: 40px;
        cursor: pointer;
        background-color: $primary;
        border: 1px solid $primary;
        padding: 0;
        padding-top: 4px;
        opacity: 1;
        color: $white;
        position: absolute;
        top: 50%;
        font-size: 25px;
        margin-top: -20px;
        @include box-sizing();
        @include radius(100%);
        @include transition();

        &.glide__arrow--right{
          right: -15px;
        }

        &.glide__arrow--left{
          left: -15px;
        }

        &.glide__arrow--disabled{
          opacity: 0;

          &:hover{
            color: $black;
            background-color: $white;
            border: 1px solid darken($white, 10%);
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.subscriptions-slider{
  .glide{
    .glide__track{
      .glide__slides{
        .glide__slide{
          .inner{
            .subscription-price{
              font-size: px2rem(12px);

              .main-price{
                margin-bottom: 10px;

                span.price {
                  display: inline-block;
                  position: relative;
                  font-weight: $fontSemiBold;
                  font-size: px2rem(26px);

                  sub {
                    display: inline-block;
                    vertical-align: top;
                    font-size: px2rem(16px);
                    @include transform(translateY(1px));
                  }

                  span {
                    position: absolute;
                    bottom: -1px;
                    right: -10px;
                    font-weight: $fontRegular;
                    font-size: px2rem(9px);
                  }
                }
              }

              .subscription-informations-text{
                min-height: 28px;
                font-size: px2rem(10px);
                line-height: px2rem(14px);
              }
            }
          }
        }
      }
    }
  }
}
</style>
